<template>
  <div
    :class="[
      'uf__shell',
      {'not_valid': error.files }
    ]"
  >
    {{ label }}
    <div class="uf__content">
      <div
        v-for="(item, index) in form.files"
        :key="index"
        :style="'background-image: url(' + get_src(item.id) + ')'"
        class="uf__content__image"
      >
        <div
          class="uf__content__delete"
        >
          <v-icon
            large
            color="rgba(0, 0, 0, 0.40)"
            @click="removeFile(item)"
          >
            mdi-close-box
          </v-icon>
        </div>
      </div>
      <div
        v-if="form.files.length < limit"
        v-cloak
        class="uf__content__trigger "
        @drop.prevent="addFile"
        @dragover.prevent
        @click="$refs.upload.click()"
      >
        <div class="uf__content__border">
          <div class="uf__content__icon" />
          <div class="uf__content__text">
            {{ btn_text }}
          </div>
        </div>
      </div>
      <input
        id="input_file"
        ref="upload"
        class="uf__content__image__file"
        type="file"
        style="display: none;"
        multiple
        accept="image/jpg,image/jpeg,image/png"
        @change="upload_files"
      >
      <div class="uf__error">
        {{ error.files }}
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .uf__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: calc(100% + 35px);
    margin-left: -17.5px;
    margin-right: -17.5px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-top: 10px;
    padding-bottom: 10px;
    position: relative;
  }
  .uf__content.no_after:after{
    content: none;
  }
  /* .uf__content:after {
    content: '';
    display: block;
    position: absolute;
    top: auto;
    bottom: 0;
    width: calc(100% - 35px);
    left: 17.5px;
    height: 1px;
    background-color: #E2E0EA;
  } */

  .uf__content__image {
    width: 125px;
    margin-left: 17.5px;
    margin-right: 17.5px;
    margin-bottom: 20px;
    height: 125px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: white;
    -webkit-box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    position: relative;
    &:hover {
      .uf__content__delete {
        opacity: 0.5;
        &:hover {
          opacity: 1;
        }
      }
    }
    .uf__content__delete {
      opacity: 0.1;
    }
  }
  .uf__content__delete {
    display: inline-block;
    width: 36px;
    height: 36px;
    /* background-image: url('./images/cross-notification.svg'); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: 26px;
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    z-index: 15;
    -webkit-transition: background-image 0.095s ease-in-out;
    -o-transition: background-image 0.095s ease-in-out;
    transition: background-image 0.095s ease-in-out;
  }
  .uf__content__trigger {
    width: calc(100% - 35px);
    margin-left: 17.5px;
    margin-right: 17.5px;
    margin-bottom: 20px;
    height: 125px;
    background-position: center;
    background-repeat: no-repeat;
    background: #F0F0F0;
    -webkit-box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
    border: 1px dashed rgba(0, 0, 0, 0.54);
    border-radius: 4px;
    cursor: pointer;
    padding: 10px;
  }
  .uf__content__border {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
  }

  .uf__shell.not_valid {
    .uf__content__trigger {
      border: 1px dashed #ff5252;
    }
    .uf__error {
      display: block;
    }
  }
  .uf__error {
    display: none;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    background: #FFDCDC;
    padding: 13px 13px 13px 21px;
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.13);
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.13);
    border: 1px dashed #ff5252;
    border-radius: 4px;
    margin-left: 17.5px;
    margin-right: 17.5px;
    z-index: 10;
  }
  @media(max-width: 575px) {
    .uf__trigger {
      width: calc(50% - 35px);
    }
    .uf__image {
      width: calc(50% - 35px);
    }
  }
  @media(max-width: 370px){
    .uf__content {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
     .uf__trigger {
      height: 160px; /* ? */

      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
    .uf__image {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>
<script>
export default {
  props: {
    single: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 10,
    },
    value: {
      type: [Array, Object],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    btn_text: {
      type: String,
      default: '+ Загрузить',
    }
  },
  data: () => ({
    mounted_flag: false,
    form: {
      files: []
    },
    error: {
      files: ''
    },
    loader: {
      show: false
    },
  }),
  computed: {},
  watch: {
    value: function () {
      this.init()
    }
  },
  mounted: function () {
  /*   var id = this.$route.query.id;
    if (id) this.load(id); */
    this.init()
  },
  methods: {
    init () {
      // if (!this.mounted_flag)
      {
        if (this.value && this.value !== [] && this.value !== {}) {
          // this.mounted_flag = true
          if (this.single) {
            if (!Array.isArray(this.value) && this.value.id) {
              this.form.files = [this.value]
            }
          } else {
            if (Array.isArray(this.value)) {
              this.form.files = this.value
            }
          }
        }
      }
    },
    get_src: function (id) {
      if (id) {
        return "/api/common/file/" + id
      } else {
        return ''
      }
    },
    addFile: async function (e) {
      const droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
      let available_limit = this.limit || 10
      if (this.limit - this.form.files.length >= droppedFiles.length) {
        available_limit = droppedFiles.length
      } else if (this.form.files.length < this.limit) {
        available_limit = this.limit - this.form.files.length
      }
      for (let i = 0; i < available_limit; i++) {
        await this.upload_files({ target: { files: [[...droppedFiles][i]] } })
      }
    },
    removeFile: function (item) {
      this.form.files = this.form.files.filter(a => a != item)
      if (this.single) {
        this.$emit('input', this.form.files && this.form.files.length > 0 ? this.form.files[0] : null)
      } else {
        this.$emit('input', this.form.files)
      }
    },
    processFile: function (file) {
      if (file) {
        return true
        var pattern = /(image.jpg|image.jpeg|image.png)/
        if (!file.type.match(pattern)) {
          return false
        } else {
          return true
        }
      }
    },
    upload_files: function (event) {
      const files = event.target.files
      this.error.files = ""
      let available_limit = this.limit || 10
      if (this.limit - this.form.files.length >= files.length) {
        available_limit = files.length
      } else if (this.form.files.length < this.limit) {
        available_limit = this.limit - this.form.files.length
      }
      for (let i = 0; i < available_limit; i++) {
        const file = files[i]
        if (file && this.processFile(file)) {
          this.loader.show = true
          const data = new FormData()
          data.append("file", file)
          this.$axios
            .post("/api/common/file/", data, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              document.getElementById("input_file").value = ""
              if (response.data.error) {
                this.$store.commit("snackbar", "Ошибка при сохранении данных")
                this.error.files = "Не удалось загрузить фотографию"
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }
                if (this.single) {
                  this.$emit('input', this.form.files && this.form.files.length > 0 ? this.form.files[0] : {})
                } else {
                  this.$emit('input', this.form.files)
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              document.getElementById("input_file").value = ""
              this.$store.commit(
                "snackbar",
                error || "Ошибка при сохранении данных"
              )
              this.loader.show = false
              this.error.files = "Не удалось загрузить фотографию"
            })
        } else {
          this.error.files = "Не удалось загрузить фотографию"
        }
      }
    }
  }
}
</script>
